<template>
    <ui-modal>
        <template #header>
            <h3 class="mb-0">Test Modal</h3>
        </template>

        <p style="text-align: justify;">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ultricies placerat mi, in luctus metus.
            Curabitur ut eros vel dolor ullamcorper ultrices cursus cursus nisl. In eget mauris magna. Curabitur
            at laoreet nulla, vel luctus tortor. Nullam eleifend eu diam ut rutrum. Fusce id consectetur magna.
            Nulla quis tristique eros. Donec non arcu nisl.
            <br /><br/>

            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ultricies placerat mi, in luctus metus.
            Curabitur ut eros vel dolor ullamcorper ultrices cursus cursus nisl. In eget mauris magna. Curabitur
            at laoreet nulla, vel luctus tortor. Nullam eleifend eu diam ut rutrum. Fusce id consectetur magna.
            Nulla quis tristique eros. Donec non arcu nisl.
            <br /><br/>

            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ultricies placerat mi, in luctus metus.
            Curabitur ut eros vel dolor ullamcorper ultrices cursus cursus nisl. In eget mauris magna. Curabitur
            at laoreet nulla, vel luctus tortor. Nullam eleifend eu diam ut rutrum. Fusce id consectetur magna.
            Nulla quis tristique eros. Donec non arcu nisl.
            <br /><br/>

            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ultricies placerat mi, in luctus metus.
            Curabitur ut eros vel dolor ullamcorper ultrices cursus cursus nisl. In eget mauris magna. Curabitur
            at laoreet nulla, vel luctus tortor. Nullam eleifend eu diam ut rutrum. Fusce id consectetur magna.
            Nulla quis tristique eros. Donec non arcu nisl.
            <br /><br/>

            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ultricies placerat mi, in luctus metus.
            Curabitur ut eros vel dolor ullamcorper ultrices cursus cursus nisl. In eget mauris magna. Curabitur
            at laoreet nulla, vel luctus tortor. Nullam eleifend eu diam ut rutrum. Fusce id consectetur magna.
            Nulla quis tristique eros. Donec non arcu nisl.
            <br /><br/>

            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ultricies placerat mi, in luctus metus.
            Curabitur ut eros vel dolor ullamcorper ultrices cursus cursus nisl. In eget mauris magna. Curabitur
            at laoreet nulla, vel luctus tortor. Nullam eleifend eu diam ut rutrum. Fusce id consectetur magna.
            Nulla quis tristique eros. Donec non arcu nisl.
            <br /><br/>

            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ultricies placerat mi, in luctus metus.
            Curabitur ut eros vel dolor ullamcorper ultrices cursus cursus nisl. In eget mauris magna. Curabitur
            at laoreet nulla, vel luctus tortor. Nullam eleifend eu diam ut rutrum. Fusce id consectetur magna.
            Nulla quis tristique eros. Donec non arcu nisl.
            <br /><br/>

            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ultricies placerat mi, in luctus metus.
            Curabitur ut eros vel dolor ullamcorper ultrices cursus cursus nisl. In eget mauris magna. Curabitur
            at laoreet nulla, vel luctus tortor. Nullam eleifend eu diam ut rutrum. Fusce id consectetur magna.
            Nulla quis tristique eros. Donec non arcu nisl.
            <br /><br/>

            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ultricies placerat mi, in luctus metus.
            Curabitur ut eros vel dolor ullamcorper ultrices cursus cursus nisl. In eget mauris magna. Curabitur
            at laoreet nulla, vel luctus tortor. Nullam eleifend eu diam ut rutrum. Fusce id consectetur magna.
            Nulla quis tristique eros. Donec non arcu nisl.
        </p>

        <template #footer>
            <the-btn class="btn-outline-custom" text="Zamknij" @click="$emit('close-modal')" />
            <the-btn class="btn-secondary" text="Dalej" />
        </template>
    </ui-modal>
</template>

<script>
export default {
    emits: ['close-modal']
}
</script>
